import { render, staticRenderFns } from "./MyVideoPlayer.vue?vue&type=template&id=27fa72cc&scoped=true&"
import script from "./MyVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./MyVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MyVideoPlayer.vue?vue&type=style&index=0&id=27fa72cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa72cc",
  null
  
)

export default component.exports